import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import ErrorBoundary from "./components/ui/ErrorBoundary";
import VintageLayout from "./components/layout/VintageLayout";
import UltimateVintageHome from "./pages/UltimateVintageHome";
import VintageBlogPost from "./pages/VintageBlogPost";
import Category from "./pages/Category";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import AdminAccess from "./components/admin/AdminAccess";

/**
 * ULTIMATE VINTAGE PORTFOLIO APPLICATION
 * 
 * Design Philosophy: Academic paper meets vintage typewriter
 * - Classic typography (IBM Plex Mono, Crimson Text, Source Serif Pro)
 * - Vintage color palette (cream, ink, sepia tones)
 * - Original comprehensive sections with vintage styling
 * - Fixed responsive design and header overlap issues
 * - Complete CRUD admin functionality
 * - Hidden admin route for secure access
 * 
 * Architecture:
 * ✅ Error boundary for graceful handling
 * ✅ Data provider for dependency injection  
 * ✅ Vintage layout with fixed header
 * ✅ Environment-based admin access
 * ✅ Hidden admin URL route
 * ✅ All original sections: Hero, Writing, Career, Education, Projects, Featured Posts
 */

function App() {
  return (
    <ErrorBoundary>
      <DataProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Hidden Admin Route - No Layout */}
              <Route path="/admin-dashboard-secret" element={<AdminAccess />} />
              
              {/* Public Routes with Layout */}
              <Route path="/*" element={
                <VintageLayout>
                  <Routes>
                    <Route path="/" element={<UltimateVintageHome />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/initiatives" element={<Projects />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/writings" element={<Blog />} />
                    <Route path="/post/:slug" element={<VintageBlogPost />} />
                    <Route path="/category/:slug" element={<Category />} />
                  </Routes>
                </VintageLayout>
              } />
            </Routes>
          </BrowserRouter>
        </div>
      </DataProvider>
    </ErrorBoundary>
  );
}

export default App;